import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowBack = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-248.89 -348.44 1777.78 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1171 1235 640 704 1171 173Q1190 154 1190.0 128.0Q1190 102 1171 83L1005 -83Q986 -102 960.0 -102.0Q934 -102 915 -83L173 659Q154 678 154.0 704.0Q154 730 173 749L915 1491Q934 1510 960.0 1510.0Q986 1510 1005 1491L1171 1325Q1190 1306 1190.0 1280.0Q1190 1254 1171 1235Z"
	})
});
export default SvgArrowBack;
